import { SimpleStatus } from '@app-velocity/common';

import { SignUpNotice } from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';

import { useNewReviewContext } from '../../../context/useNewReviewContext';

export type GuestNoticeProps = {
  originalReviewsCount: number;
  filteredReviewsCount: number;
  reviewStatus: SimpleStatus | null;
};

export const GuestNotice = ({
  originalReviewsCount,
  filteredReviewsCount,
  reviewStatus,
}: GuestNoticeProps) => {
  const { mode } = useNewReviewContext();
  const { t } = useI18n();

  if (mode !== 'guest' || reviewStatus !== 'paused') return null;

  const leftAppraisals = originalReviewsCount - filteredReviewsCount;

  return (
    <SignUpNotice
      badge={
        leftAppraisals > 5
          ? t('appraisals:guest_notice.badge', {
              count: leftAppraisals,
            })
          : t('appraisals:guest_notice.badge_more')
      }
      title="appraisals:guest_notice.title"
      text="appraisals:guest_notice.text"
      action="appraisals:get_full_review"
    />
  );
};
